import { j as n } from "./atoms-v218.js";
import { useState as o, useEffect as f } from "react";
import { Skeleton as l } from "./atoms-v21267.js";
import { measureText as i, getTextHeight as a, getFont as u } from "./atoms-v21268.js";
function j(x) {
  const e = document.createElement("canvas").getContext("2d");
  return function(t) {
    const [c, r] = o(i(t.textConfig, e)), [s, d] = o(a(t.textConfig));
    return f(() => {
      r(i(t.textConfig, e)), d(a(t.textConfig)), e && (e.font = u(t.textConfig));
    }, []), t.isLoading ? /* @__PURE__ */ n.jsx(
      l,
      {
        $height: s,
        $width: c,
        "aria-label": "skeleton-text-loader",
        "data-testid": "calculated-text-skeleton-hoc"
      }
    ) : /* @__PURE__ */ n.jsx(x, { ...t, "data-testid": "calculated-text-skeleton-wrapped-component" });
  };
}
export {
  j as calculatedTextSkeletonHOC
};
